import { render, staticRenderFns } from "./HoldingCode.vue?vue&type=template&id=41ed28a0"
import script from "./HoldingCode.vue?vue&type=script&lang=js"
export * from "./HoldingCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports